import { Injectable, inject } from '@angular/core';
import {
    IRelatedProductsCallback,
    IRelatedProductsOptions,
    RelatedProductsService
} from '@df/catalog-ui/related-products/related-products.service';
import { ProductResource } from '@df/catalog/product/product.resource';
import compact from 'lodash-es/compact';
import { ExponeaServiceDef } from './exponea.service.def';
import { Exponea } from './exponea.types';

@Injectable({
    providedIn: 'root'
})
export class ExponeaRecommendationsEngine {
    protected exponeaService = inject(ExponeaServiceDef);
    protected productResource = inject(ProductResource);

    get(
        sourceIds: number[],
        cb: IRelatedProductsCallback,
        engineOptions: Exponea.IRecommendationsEngineOptions,
        options: IRelatedProductsOptions
    ) {
        if (engineOptions.options) {
            const skus = compact(sourceIds?.map(i => this.productResource.get(i)?.data?.sku) || []);
            this.exponeaService
                .loadRecommendationsProductIds(engineOptions.options, skus)
                .then(cb)
                .catch(() => {
                    cb([]);
                });
        } else {
            cb([]);
        }
    }
}

RelatedProductsService.registerEngine(Exponea.recommendationsEngineId, ExponeaRecommendationsEngine);
